<template>
  <div :class="getClasses" :key="'message-counter-'+deliverable.id+'-'+deliverable.unread_message_count" @click="clickMessageCounter">
  	<img v-if="deliverable.unread_message_count == 0 && deliverable.total_message_count > 0 && !deliverable.is_master" src="@/csmworkflow/img/chat-bubbles-read.svg" class="chat-bubbles-read" />
  	<img v-if="deliverable.unread_message_count == 0 && deliverable.total_message_count > 0 && deliverable.is_master" src="@/csmworkflow/img/chat-bubbles-master-read.svg" class="chat-bubbles-master-read" />
  	<img v-if="deliverable.unread_message_count > 0 && deliverable.is_master" src="@/csmworkflow/img/chat-bubbles-master-unread.svg" class="chat-bubbles-master-unread" />
  	<img v-if="deliverable.unread_message_count > 0 && !deliverable.is_master" src="@/csmworkflow/img/chat-bubbles-unread.svg" class="chat-bubbles-unread" />
  	<img v-if="deliverable.total_message_count == 0" src="@/csmworkflow/img/chat-bubbles-none.svg" class="chat-bubbles-none" />
  	<span class="message-count" v-if="deliverable.unread_message_count > 0" v-html="deliverable.unread_message_count"></span>
  </div>
</template>
<style scoped>
.message-counter{
  padding: 10px 0px;
  text-align:center;
  color:#000;
  font-weight: 600;
  position: absolute;
	cursor: pointer;
	top:0; left:0; right:0; bottom:0;
	display: flex;
	align-items: center;
	justify-content: center;
}
.message-counter:hover{
	background: #f4f4f4;
}

.message-counter.is-master span {
			color:#4C9850 !important;
}

.message-counter img {
	max-width:52px;
}
.message-counter img.chat-bubbles-none{
	padding: 5px;
}

.message-counter span {
	position:absolute;
	display:block;
  width:100%;
	left:-4px;
	top:23px;
	color:#fff;
}

</style>

<script>
import {mapGetters} from "vuex"

export default{
  data() {
    return {

    }
  },
  props: ['deliverable'],
  computed: {
		getClasses() {
  		let classes = "message-counter";
  		if (this.deliverable) {
  			if (this.deliverable.is_master) {
  				classes += " is-master";
  			}
  		}
  		return classes;
  	}
  },
  methods: {
		clickMessageCounter(){
			this.$emit("clickMessageCounter");
		}
  },
  created(){
  }
}
</script>